// src/settings/components/LabeledInput.jsx
import React from "react";

export default function LabeledInput({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  name,
  autoComplete,
  inputMode,
  disabled,
  required,
  error,
}) {
  const id = name || label.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label} {required ? <span className="field__required">*</span> : null}
      </label>

      <input
        id={id}
        className={`field__input ${error ? "hasError" : ""}`}
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputMode={inputMode}
        disabled={disabled}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
      />

      {error ? (
        <div className="field__error" id={`${id}-error`}>
          {error}
        </div>
      ) : null}
    </div>
  );
}